// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';

angular.module('directives.visualizations.chartLabel', [])
  .directive('chartLabel', [
    function() {
      return {
        restrict: 'E',
        template:
          '<div ' +
            'class="chart-label" ' +
            'ng-class="{\'with-arrow\': arrow}" ' +
            'ng-style="position" ' +
            'ng-show="visibility">' +
            '<div class="chart-label-key">' +
              '{{ key }}' +
            '</div>' +
            '<div class="chart-label-value">' +
              '{{ value }}' +
            '</div>' +
            '<div ng-if="arrow" class="chart-label-arrow">' +
            '</div>' +
          '</div>',
        scope: {
          position: '=',
          visibility: '=',
          key: '=',
          value: '=',
          arrow: '='
        }
      };
    }
  ]);
